import React, { useState, useMemo } from 'react';
import { Typography, Input, Select, Flex } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import NewsCard from '../../components/News/NewsCard';
import IntlMessage from '../../components/IntlMessage/IntlMessage';
import { newsData } from '../../data/newsData';
import styles from '../../components/News/news.module.css';

const { Title, Paragraph } = Typography;
const { Search } = Input;
const { Option } = Select;

const NewsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('date-desc');

  // Фильтрация и сортировка новостей
  const filteredAndSortedNews = useMemo(() => {
    let filtered = newsData.filter(news =>
      news.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      news.excerpt.toLowerCase().includes(searchTerm.toLowerCase())
    );

    switch (sortBy) {
      case 'date-desc':
        return filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
      case 'date-asc':
        return filtered.sort((a, b) => new Date(a.date) - new Date(b.date));
      case 'title-asc':
        return filtered.sort((a, b) => a.title.localeCompare(b.title));
      case 'title-desc':
        return filtered.sort((a, b) => b.title.localeCompare(a.title));
      default:
        return filtered;
    }
  }, [searchTerm, sortBy]);

  const handleNewsClick = (news) => {
    navigate(`/news/${news.id}`);
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
  };

  const handleSortChange = (value) => {
    setSortBy(value);
  };

  return (
    <div className={styles.newsPage}>
      <Header />
      
      <div className={styles.pageHeader}>
        <Title level={1} className={styles.pageTitle}>
          <IntlMessage id={'newsPage.title'}/>
        </Title>
        <Paragraph className={styles.pageSubtitle}>
          <IntlMessage id={'newsPage.subtitle'}/>
        </Paragraph>
      </div>

      <div className={styles.pageContent}>
        <div className={styles.newsFilters}>
          <Search
            placeholder={t('newsPage.search.placeholder')}
            allowClear
            size="large"
            style={{ maxWidth: 400, width: '100%' }}
            onSearch={handleSearch}
            onChange={(e) => setSearchTerm(e.target.value)}
            prefix={<SearchOutlined />}
          />
          
          <Select
            value={sortBy}
            onChange={handleSortChange}
            size="large"
            style={{ minWidth: 200 }}
          >
            <Option value="date-desc">
              <IntlMessage id={'newsPage.sort.dateDesc'}/>
            </Option>
            <Option value="date-asc">
              <IntlMessage id={'newsPage.sort.dateAsc'}/>
            </Option>
            <Option value="title-asc">
              <IntlMessage id={'newsPage.sort.titleAsc'}/>
            </Option>
            <Option value="title-desc">
              <IntlMessage id={'newsPage.sort.titleDesc'}/>
            </Option>
          </Select>
        </div>

        {filteredAndSortedNews.length > 0 ? (
          <div className={styles.newsList}>
            {filteredAndSortedNews.map((news) => (
              <NewsCard
                key={news.id}
                news={news}
                onClick={handleNewsClick}
                compact={true}
              />
            ))}
          </div>
        ) : (
          <Flex justify="center" align="center" style={{ padding: '60px 0' }}>
            <div style={{ textAlign: 'center' }}>
              <Title level={3} style={{ color: '#8c8c8c' }}>
                <IntlMessage id={'newsPage.noResults.title'}/>
              </Title>
              <Paragraph style={{ color: '#8c8c8c' }}>
                <IntlMessage id={'newsPage.noResults.description'}/>
              </Paragraph>
            </div>
          </Flex>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default NewsPage; 